import type { DmLevel } from '@change-corgi/middle-end-gql-schema';

const OUTREACH_ELIGIBLE_LEVELS: readonly DmLevel[] = ['LOCAL_CITY_COUNTY', 'LOCAL_STATE'];

/**
 * Whether a petition is in the supporter → decision maker outreach audience: it has a local
 * (city/county) or state decision maker. Shared by every surface that mounts the contact flow, so
 * they cannot disagree on who qualifies.
 *
 * Fails closed: `undefined` (the metadata fetch failed) and an empty list (DMI has not classified the
 * petition yet) both read as ineligible.
 */
export function isOutreachEligiblePetition(levels: readonly DmLevel[] | undefined): boolean {
	return !!levels?.some((level) => OUTREACH_ELIGIBLE_LEVELS.includes(level));
}
